enum InputError {
    Required,
    InvalidEmail,
    NoMatch,
    InvalidPassword,
}

export default InputError;
